import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';
import { getIdsFromPath } from '@/utils';

const useGetReportEmployerId = () => {
  const { observingOrganization, observingEmployer } = useCurrentOrganization();
  const isSubsidiary = useMemo(() => {
    return observingOrganization?.type === OrganizationTypes.subsidiary;
  }, [observingOrganization]);

  const { employerId: forceEmployerId } = useMemo(
    () => getIdsFromPath(observingOrganization.path),
    [observingOrganization.path]
  );


  const employerId = useMemo(() => {
    if (isSubsidiary && forceEmployerId) {
      return forceEmployerId;
    }
    if (
      observingEmployer
    ) {
      return `${observingEmployer.id || ''}`;
    }

    return '';
  }, [forceEmployerId, isSubsidiary, observingEmployer]);
  return employerId;
};
export default useGetReportEmployerId;
